import { render } from "./NoticeViewer.vue?vue&type=template&id=025055e8&scoped=true"
import script from "./NoticeViewer.vue?vue&type=script&lang=js"
export * from "./NoticeViewer.vue?vue&type=script&lang=js"

import "./NoticeViewer.vue?vue&type=style&index=0&id=025055e8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4192554447/src/github.com/DeepAngle/DDR-Atlas-Proto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-025055e8"]])

export default __exports__